import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import type { FC } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthenticated } from '../../utils/auth/index.js';
import { getSharedDevice, setSharedDevice } from '../../utils/shared-device.js';
import type { DeviceSettings } from '../device-settings/types.js';
import { EditView } from './edit.view.js';

export const EditDeviceSettingsPage: FC = () => {
  const auth = useAuthenticated();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik<DeviceSettings>({
    initialValues: {
      sharedDevice: getSharedDevice(),
    },
    onSubmit: (values) => {
      setSharedDevice(values.sharedDevice);
      enqueueSnackbar('Updated', { variant: 'success' });
      navigate(-1);
    },
  });

  if (auth.userInfo.hasRole('admin')) {
    return <EditView cancel={() => navigate(-1)} formik={formik} />;
  }

  return <Navigate replace to="/" />;
};
